import { render, staticRenderFns } from "./Ponta.vue?vue&type=template&id=bbf4c572&scoped=true&"
import script from "./Ponta.vue?vue&type=script&lang=js&"
export * from "./Ponta.vue?vue&type=script&lang=js&"
import style0 from "./Ponta.vue?vue&type=style&index=0&id=bbf4c572&scoped=true&land=scss&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbf4c572",
  null
  
)

export default component.exports